import { createSwiper, withResize } from '../../components/swiper-init.js';

// Three swipers live on this page, each reusing a key from elsewhere in the
// site so the markup and slide styling stay consistent:
//
//   is--webinar-inner → "What to expect" 3-step section. Matches the webinar
//                       template — default mobile-only behavior (disabled
//                       at >=992px where the steps lay out as a row).
//
//   is--cs            → "Signal Engineering in Action" case studies carousel.
//                       Matches home/swiper-cs.js exactly — the page embeds
//                       the same `.swiper-slide.is--home.swiper-slide-active
//                       .double-item_left` transition CSS, so it needs
//                       initialSlide: 1 to start with the coupling effect
//                       active. Stays enabled on desktop.
//
//   is--articles      → "Resources to Go Deeper" articles row. The page-level
//                       embedded style hides nav at >=992px only for
//                       is--blog/is--blog-2 — is--articles keeps its nav,
//                       so it stays enabled on desktop with auto-width slides.
export function initSwipersWithResize() {
  withResize(() => {
    createSwiper('is--webinar-inner');
    createSwiper('is--cs', {
      breakpoints: {
        992: { slidesPerView: 'auto', initialSlide: 1 },
      },
    });
    createSwiper('is--articles', {
      breakpoints: {
        992: { slidesPerView: 'auto' },
      },
    });
  });
}
